import mitt, { Emitter } from "mitt";

export interface IConfirmationAlert {
  title?: string | null;
  message?: string | null;
  confirmationButtonLabel?: string | null;
  cancellationButtonLabel?: string | null;
  confirmCallback: () => Promise<void> | void | null;
  cancelCallback?: () => Promise<void> | void | null;
  buttonColor?: string | null;
  submitting?: boolean;
}

export enum EventBusNames {
  SHOW_CONFIRMATION_ALERT = "SHOW_CONFIRMATION_ALERT",
  SHOW_TOAST = "SHOW_TOAST",
  GET_CREDIT_CARDS = "GET_CREDIT_CARDS",

  // EXCLUSIVOS DO MAIN (não existem no psiapp-vue-pro)
  SHOW_ERROR_TOAST = "SHOW_ERROR_TOAST",
  REFRESH_APPOINTMENT = "REFRESH_APPOINTMENT",
  ACCOUNT_UPDATED = "ACCOUNT_UPDATED",
  SHOW_SETTINGS_MODAL = "SHOW_SETTINGS_MODAL",
  OPEN_PAMIA = "OPEN_PAMIA",
}

export type Events = {
  [EventBusNames.SHOW_CONFIRMATION_ALERT]: IConfirmationAlert;
  [EventBusNames.SHOW_TOAST]: { msg: string; title: string };
  [EventBusNames.GET_CREDIT_CARDS]: void;
  [EventBusNames.SHOW_ERROR_TOAST]: { msg?: string; title?: string };
  [EventBusNames.REFRESH_APPOINTMENT]: void;
  [EventBusNames.ACCOUNT_UPDATED]: void;
  [EventBusNames.SHOW_SETTINGS_MODAL]: { key: string };
  [EventBusNames.OPEN_PAMIA]: void;
};

// Create the event bus
const emitter: Emitter<Events> = mitt<Events>();

// Export the event bus for use in components
export const EventBus = {
  $on: emitter.on,
  $off: emitter.off,
  $emit: emitter.emit,
};
